import { render, staticRenderFns } from "./intelligentAnswering_v2.vue?vue&type=template&id=2c4b0c4b&scoped=true&"
import script from "./intelligentAnswering_v2.vue?vue&type=script&lang=js&"
export * from "./intelligentAnswering_v2.vue?vue&type=script&lang=js&"
import style0 from "./intelligentAnswering_v2.vue?vue&type=style&index=0&id=2c4b0c4b&prod&scoped=true&lang=scss&"
import style1 from "./intelligentAnswering_v2.vue?vue&type=style&index=1&id=2c4b0c4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4b0c4b",
  null
  
)

export default component.exports